import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { clone } from 'lodash';
import moment from 'moment-timezone';
import { func, string, object, array } from 'prop-types';
import getFormattedError from '../../api-wrapper/get-formatted-error.js';
import useApi from '../../api-wrapper/use-api.js';
import {
   URL_NEW_DISTRIBUTION_GROUP_SEARCH,
   URL_DISTRIBUTION_GROUP_APPROVED,
   URL_NEW_DISTRIBUTION_GROUP_GENERATE,
   URL_CORE_PRICING_DELETE_DISTRIBUTION,
} from '../../end-points.js';
import SearchCriteria from '../../ui-components/core-pricing-component/search-cirteria/search-criteria.jsx';
import TableView from '../../ui-components/core-pricing-component/table-view/table-view.jsx';
import LayoutTwoVerticalGrids from '../../ui-components/layouts/layout-two-vertical-grids.jsx';
import Loader from '../../ui-components/loader/loader.jsx';
import {
   parsingRequestData,
   calculateHeader,
   calculateResultDetails,
   updateData,
   getClonedCopyCollections,
   calculateResultDetailsUnique,
   emptyValidation,
   amountEmptyFieldValidation,
   dateTimeFormat,
   deleteItems,
   calculateMergeData,
   copyTableData,
} from '../../utils/common-util.js';
import {
   SIZE,
   DEFAULT_DG_LOG_HEADER,
   DATE_TIME_FIELD_KEY,
   CAMEL_CASE_ACTION,
   CAMEL_CASE_TYPES,
   USER_ACTION_CODE_FARES_SCREEN,
   SCREEN_NAMES,
} from '../../utils/constants.js';
import { DateUtil } from '../../utils/date-util.js';
import { getApiHeaders } from '../../utils/header-util.js';
import { NOTIFICATION_MESSAGES } from '../../utils/notification-messages.js';
import { toastSuccess, toastWarn } from '../../utils/toasts.js';

const DistributionGroup = ({
   app,
   getSearchCriteriaParent,
   selectedScreen,
   getTableData,
   handleDeleteDistributionMenuClick,
   deleteConformedDistributionList,
}) => {
   const [distributionGroupConfig, setDistributionGroupConfig] = useState({
      isLeftSideLayoutOpen: true,
      distributionGroupData: [],
      distributionGroupDefaultData: [],
      distributionGroupHeader: [],
      distributionGroupDefaultHeader: [],
      selectedRowDetails: {},
      isFilterApply: false,
      isSaveSearchCriteria: false,
      distributionLogHeader: [],
      distributionLogData: [],
      distributionLogDefaultData: [],
      distributionLogNotesFieldText: '',
      saveMode: '',
   });
   const secondaryTableReference = useRef();
   const [searchCriteriaConfig, setSearchCriteriaConfig] = useState({});
   const [approvedApiCall, setApprovedApiCall] = useApi({});
   const [newDistributionApiCall, setNewDistributionApiCall] = useApi({});
   const [distributionSaveApi, setDistributionSaveApi] = useApi({});
   const [fetchConfig, setFetchConfig] = useState({
      data: [],
      isLoading: false,
      error: '',
      requestedData: [],
      isStopAPI: false,
      url: URL_NEW_DISTRIBUTION_GROUP_SEARCH,
   });
   const [abort, setAbort] = useState({
      isAbort: false,
      searchCriteriaDetails: [],
   });
   const [cancelToken, setCancelToken] = useState(null);
   const handleStatusLeftSideLayout = (isLeftSideLayoutOpen) => {
      setDistributionGroupConfig({
         ...distributionGroupConfig,
         isLeftSideLayoutOpen,
      });
   };
   const showWarning = (message) => {
      toastWarn(message);
   };
   const showSuccess = (message) => {
      toastSuccess(message);
   };

   useEffect(() => {
      if (
         deleteConformedDistributionList &&
         distributionGroupConfig.distributionGroupData.length > 0
      ) {
         showSuccess('Distribution group deleted successfully');
         removedSelectedDistributionListItems();
      }
   }, [deleteConformedDistributionList]);

   useEffect(() => {
      if (approvedApiCall.data.length > 0) {
         showSuccess('Distribution group Approved successfully.');
         updateLatestRecord(approvedApiCall.data, 'Distributed');
      } else if (approvedApiCall.error) {
         toastWarn(approvedApiCall.error.content);
      }
   }, [approvedApiCall.isLoading]);

   const validateIntDistributionDateTime = (type, data) => {
      const editedResult =
         type === 'main_table_update'
            ? distributionGroupConfig.distributionGroupData.filter(
                 (list) => list.uac === USER_ACTION_CODE_FARES_SCREEN.UPDATE
              )
            : data.isAllowDistributionApiCall &&
              type === 'log_table_update' && [data];
      let isValid = false;
      if (editedResult?.length > 0)
         editedResult.forEach((item) => {
            if (item['int dist dt'] && DateUtil.validate(item['int dist dt']))
               isValid = true;
            else isValid = false;
         });
      else if (type === 'main_table_update') isValid = true;
      return isValid;
   };
   const updateLatestRecord = (data, type) => {
      const gridData = clone(distributionGroupConfig.distributionGroupData);
      const result = distributionTableParsing(data);
      result.forEach((list) => {
         const index = gridData.findIndex((subList) => subList.dg === list.dg);
         gridData[index] = list;
      });
      if (
         (distributionGroupConfig.distributionGroupData.filter(
            (list) => list.isAllowDistributionApiCall
         ).length > 0 &&
            distributionGroupConfig.saveMode === 'Save') ||
         (distributionGroupConfig.saveMode === 'Note' &&
            distributionGroupConfig.distributionGroupData[
               distributionGroupConfig.selectedRowDetails.currentRow
            ].isAllowDistributionApiCall &&
            type === 'Save')
      ) {
         distributionApprove();
      }
      setDistributionGroupConfig({
         ...distributionGroupConfig,
         distributionGroupData: gridData,
         distributionGroupDefaultData: gridData,
         distributionLogData:
            gridData[distributionGroupConfig.selectedRowDetails.currentRow]
               .distributionGroupLogs,
         distributionLogDefaultData:
            gridData[distributionGroupConfig.selectedRowDetails.currentRow]
               .distributionGroupLogs,
      });
   };
   useEffect(() => {
      if (
         distributionSaveApi.data &&
         distributionGroupConfig.distributionGroupData.length > 0 &&
         !distributionSaveApi.error &&
         !distributionSaveApi.isLoading
      ) {
         showSuccess('Distribution group saved successfully.');
         updateLatestRecord(distributionSaveApi.data, 'Save');
      } else if (distributionSaveApi.error) {
         toastWarn(distributionSaveApi.error.content);
      }
   }, [distributionSaveApi.isLoading]);

   const getSearchCriteria = (searchCriteria, type) => {
      setSearchCriteriaConfig(searchCriteria);
      if (type === 'clear') {
         setFetchConfig({
            ...fetchConfig,
            data: [],
            isLoading: false,
            error: '',
            requestedData: {
               hostCarrier: fetchConfig.requestedData.hostCarrier,
            },
            isStopAPI: false,
         });
      }
   };
   const validateDate = (filterSearchQuery) => {
      const validCategories = filterSearchQuery.categoryDetails.filter(
         (fieldDetails) =>
            fieldDetails?.values?.length > 0 &&
            fieldDetails?.values?.every((value) => value)
      );
      if (validCategories.length > 0) {
         let isValidDate = true;
         validCategories.forEach((field) => {
            if (
               DATE_TIME_FIELD_KEY.includes(field.key) &&
               field.values?.length > 0 &&
               !moment(
                  field.values,
                  DateUtil.DATE_FORMATS.DD_MMM_YY_TIME,
                  true
               ).isValid()
            ) {
               isValidDate = false;
               toastWarn(
                  `${field.keyCode} ${NOTIFICATION_MESSAGES.INVALID_DATE_TIME_FORMAT}`
               );
            }
         });
         return isValidDate;
      } else return true;
   };

   const searchCriteriaParsing = (searchCriteriaConfig) => {
      const getSearchDetails = [...searchCriteriaConfig];
      const filterRecords = getSearchDetails.filter(
         (list) => list.categoryName === 'Distribution Groups'
      );
      if (!validateDate(filterRecords[0])) return;
      const result = parsingRequestData(filterRecords);
      const updatedData = deleteItems(result.data);
      updatedData.hostCarrier = sessionStorage.getItem('carrierCode');
      updatedData.pageToken = null;
      updatedData.jobId = null;
      if (!result.isEmptyValue) {
         setFetchConfig({
            ...fetchConfig,
            data: [],
            isLoading: true,
            error: '',
            requestedData: updatedData,
            isStopAPI: false,
         });
         setDistributionGroupConfig({
            ...distributionGroupConfig,
            distributionGroupData: [],
            distributionGroupDefaultData: [],
            distributionGroupHeader: [],
            distributionGroupDefaultHeader: [],
            distributionLogHeader: [],
            distributionLogData: [],
            distributionLogDefaultData: [],
            isLeftSideLayoutOpen: false,
         });
      } else toastWarn(NOTIFICATION_MESSAGES.EMPTY_FIELD);
   };
   const handleUpdateSearchCriteriaConfigClick = async (
      searchCriteriaConfig
   ) => {
      if (abort.isAbort) {
         cancelTokenSource.abort();
         handleUpdateSearchCriteriaConfigClick(searchCriteriaConfig);
         return;
      }
      if (fetchConfig.isLoading) {
         cancelTokenSource.abort();
         setAbort({
            isAbort: true,
            searchCriteriaDetails: searchCriteriaConfig,
         });
      } else {
         searchCriteriaParsing(searchCriteriaConfig);
      }
   };
   const updateRecords = (item, totalList) => {
      let currentRecord = 0;
      const updatedResult = totalList.map((list) => {
         if (list.key === item.key) {
            if (item.isDefault || item.isDecending) {
               list.isAscending = true;
               list.isDefault = false;
               list.isDecending = false;
            } else if (item.isAscending) {
               list.isDecending = true;
               list.isAscending = false;
            }
            currentRecord = list;
         }

         return list;
      });
      return { updatedResult, currentRecord };
   };
   const handleSorting = (item) => {
      const primaryTableObject = updateRecords(
         item,
         distributionGroupConfig.distributionGroupHeader
      );
      const currentRecord = primaryTableObject.currentRecord;
      const sortedData = distributionGroupConfig.distributionGroupData.sort(
         (a, b) => {
            if (!parseInt(a[currentRecord.key]))
               return a[currentRecord.key]
                  .toString()
                  .localeCompare(b[currentRecord.key].toString());
            else {
               if (
                  item.key !== 'created' &&
                  item.key !== 'last update' &&
                  item.key !== 'dist dt' &&
                  item.key !== 'timestamp'
               ) {
                  return parseInt(a[currentRecord.key] - b[currentRecord.key]);
               } else {
                  return new Date(a[currentRecord.key]) >
                     new Date(new Date(b[currentRecord.key]))
                     ? 1
                     : -1;
               }
            }
         }
      );
      const sortedResult = currentRecord.isAscending
         ? sortedData
         : sortedData.reverse();

      setDistributionGroupConfig({
         ...distributionGroupConfig,
         distributionGroupData: sortedResult,
         distributionGroupHeader: primaryTableObject.updatedResult,
         distributionLogData:
            sortedResult[distributionGroupConfig.selectedRowDetails.currentRow]
               .distributionGroupLogs,
      });
   };
   const handleLogTableSorting = (item) => {
      const primaryTableObject = updateRecords(
         item,
         distributionGroupConfig.distributionLogHeader
      );

      const currentRecord = primaryTableObject.currentRecord;

      const sortedData = distributionGroupConfig.distributionLogData.sort(
         (a, b) => {
            if (!parseInt(a[currentRecord.key]))
               return a[currentRecord.key]
                  .toString()
                  .localeCompare(b[currentRecord.key].toString());
            else {
               if (
                  item.key !== 'created' &&
                  item.key !== 'last update' &&
                  item.key !== 'dist dt' &&
                  item.key !== 'timestamp'
               ) {
                  return parseInt(a[currentRecord.key] - b[currentRecord.key]);
               } else {
                  return new Date(a[currentRecord.key]) >
                     new Date(new Date(b[currentRecord.key]))
                     ? 1
                     : -1;
               }
            }
         }
      );
      const sortedResult = currentRecord.isAscending
         ? sortedData
         : sortedData.reverse();
      setDistributionGroupConfig({
         ...distributionGroupConfig,
         distributionLogData: sortedResult,
         distributionLogHeader: primaryTableObject.updatedResult,
      });
   };
   const handleStopSearchRequest = () => {
      if (cancelToken) {
         cancelToken.cancel('Query canceled');
         setCancelToken(null);
      }
      setTimeout(() => {
         setFetchConfig(
            {
               ...fetchConfig,
               isStopAPI: true,
               isLoading: false,
            },
            10
         );
      });
   };

   const generateUniqueItem = (data) => {
      const result = data.map((list) => {
         list.id = Math.random();
         return list;
      });
      return result;
   };
   const distributionTableParsing = (distributionData) => {
      let distributionCollection = [];
      distributionData.map((item) => {
         const {
            dgNumber,
            createdAt,
            lastUpdatedAt,
            distributedAt,
            description,
            user,
            totalFare,
            intDistributionTimeStamp,
            exclusiveAccessIndicator,
            releaseIndicator,
            ignoreErrorsIndicator,
            lowFareCheckIndicator,
            taxIndicator,
            justification,
            email,
            status,
            isDomesticOrInternational,
            distributionGroupLogs,
         } = item;

         const dgLogs = [];
         distributionGroupLogs &&
            distributionGroupLogs.length > 0 &&
            distributionGroupLogs.map((subItem) => {
               const { timeStamp, action, notes } = subItem;
               const logRow = {
                  timestamp: DateUtil.estTime(
                     timeStamp ? new Date(timeStamp) : new Date()
                  ).format(
                     DateUtil.DATE_FORMATS
                        .DOMAIN_DATE_TIME_TIMEZONE_WITH_MILLI_SECONDS_PATTERN
                  ),
                  'cr user': emptyValidation(user),
                  action: emptyValidation(action),
                  notes: emptyValidation(notes),
               };
               dgLogs.push(logRow);
            });

         const row = {
            dg: emptyValidation(dgNumber),
            created: dateTimeFormat(emptyValidation(createdAt)),
            'last update': dateTimeFormat(emptyValidation(lastUpdatedAt)),
            createdAt: createdAt,
            lastUpdatedAt: lastUpdatedAt,
            'dist dt': dateTimeFormat(emptyValidation(distributedAt)),
            description: emptyValidation(description),
            'cr user': emptyValidation(user),
            fare: amountEmptyFieldValidation(totalFare),
            'int dist dt': dateTimeFormat(
               emptyValidation(intDistributionTimeStamp)
            ),
            'ex ind': emptyValidation(exclusiveAccessIndicator),
            'rel ind': emptyValidation(releaseIndicator),
            'ign err': emptyValidation(ignoreErrorsIndicator),
            lfc: emptyValidation(lowFareCheckIndicator),
            'tax ind': emptyValidation(taxIndicator),
            justification: emptyValidation(justification),
            email: emptyValidation(email),
            status: emptyValidation(status),
            'd/i': emptyValidation(isDomesticOrInternational),
            distributionGroupLogs:
               distributionGroupLogs && distributionGroupLogs.length > 0
                  ? dgLogs
                  : [],
         };
         distributionCollection.push(row);
      });
      return distributionCollection;
   };
   const parsingOriginalData = (distributionData) => {
      if (distributionData && distributionData.length > 0) {
         let distributionCollection =
            distributionTableParsing(distributionData);
         const header = calculateHeader(
            distributionCollection[0],
            'Distribution'
         );
         const logHeader = calculateHeader(
            DEFAULT_DG_LOG_HEADER[0],
            'Distribution'
         );
         const updatedLogHeader = calculateResultDetails(
            DEFAULT_DG_LOG_HEADER,
            logHeader
         );
         const filterHeader = header.filter((list) => list);
         const result = calculateResultDetails(
            distributionCollection,
            filterHeader
         );
         const uniqueIdAddedRecords = generateUniqueItem(
            distributionCollection
         );
         const logData = generateUniqueItem(
            uniqueIdAddedRecords[0].distributionGroupLogs
         );
         getTableData({
            joinTable: uniqueIdAddedRecords,
            primaryTableLength: uniqueIdAddedRecords.length,
            totalItem: uniqueIdAddedRecords.length,
            isCompleted: true,
         });
         showSuccess('Successfully fetch all data.Export data available now');
         setDistributionGroupConfig({
            ...distributionGroupConfig,
            distributionGroupData: uniqueIdAddedRecords,
            distributionGroupHeader: result,
            distributionGroupDefaultData: uniqueIdAddedRecords,
            distributionGroupDefaultHeader: result,
            distributionLogHeader: updatedLogHeader,
            distributionLogData: logData,
         });

         setFetchConfig({
            ...fetchConfig,
            isLoading: false,
         });
      }
   };
   const callFetchFaresService = async () => {
      const headers = {};
      if (cancelToken) {
         cancelToken.cancel('Query canceled.');
      }
      const requestObject = Object.assign(fetchConfig);
      try {
         const source = axios.CancelToken.source();
         setCancelToken(source);
         const fetchResultData = await axios({
            url: URL_NEW_DISTRIBUTION_GROUP_SEARCH,
            method: 'POST',
            cancelToken: source.token,
            headers: getApiHeaders(),
            data: requestObject.requestedData.distributionGroups,
         }).catch((err) => {
            setFetchConfig({
               ...fetchConfig,
               error: err.message,
               data: [],
               isLoading: false,
            });
         });
         if (fetchResultData) {
            setFetchConfig({
               ...fetchConfig,
               data: fetchResultData.data,
               isLoading: false,
               error: '',
               isStopAPI: false,
            });
            if (fetchResultData.data.length === 0) {
               toastWarn(NOTIFICATION_MESSAGES.NO_DATA_AVAILABLE);
               return;
            }
            parsingOriginalData(fetchResultData.data);
         }
      } catch (error) {
         setFetchConfig({
            ...fetchConfig,
            data: [],
            isLoading: false,
            error: getFormattedError(error).content,
         });
         setAbort({
            isAbort: false,
         });
      }
   };

   useEffect(() => {
      getSearchCriteriaParent(searchCriteriaConfig);
   }, [searchCriteriaConfig]);

   useEffect(() => {
      if (fetchConfig.error === 'canceled' && abort.isAbort) {
         searchCriteriaParsing(abort.searchCriteriaDetails);
      } else if (fetchConfig.error && fetchConfig.error !== 'canceled') {
         toastWarn(fetchConfig.error);
      }
   }, [fetchConfig.error]);

   useEffect(() => {
      if (
         fetchConfig.isLoading &&
         !distributionGroupConfig.isSaveSearchCriteria
      ) {
         callFetchFaresService();
      }
   }, [fetchConfig.isLoading]);
   const searchCriteriaComponent = () => {
      return (
         <SearchCriteria
            currentScreen={'Distribution'}
            showWarning={showWarning}
            getSearchCriteria={getSearchCriteria}
            data={searchCriteriaConfig}
            handleSearchCriteriaSearch={handleUpdateSearchCriteriaConfigClick}
            handleStopSearchRequest={() => handleStopSearchRequest()}
         />
      );
   };
   const handleOutSideClick = () => {
      setDistributionGroupConfig({
         ...distributionGroupConfig,
         selectedRowDetails: {
            currentRow: distributionGroupConfig.selectedRowDetails.currentRow,
            selectedCellIndex: -2,
            selectedCellTableType: CAMEL_CASE_TYPES.PRIMARY_TABLE,
            selectedRowIndex:
               distributionGroupConfig.selectedRowDetails.selectedRowIndex,
         },
      });
   };
   const getSelectedIndex = (selectedRowDetails) => {
      setDistributionGroupConfig({
         ...distributionGroupConfig,
         selectedRowDetails: selectedRowDetails,
         distributionLogData:
            distributionGroupConfig.distributionGroupData[
               selectedRowDetails.currentRow
            ] && selectedRowDetails.selectedRowIndex.length === 1
               ? distributionGroupConfig.distributionGroupData[
                    selectedRowDetails.currentRow
                 ].distributionGroupLogs &&
                 distributionGroupConfig.distributionGroupData[
                    selectedRowDetails.currentRow
                 ].distributionGroupLogs
               : [],
         distributionLogDefaultData:
            distributionGroupConfig.distributionGroupData[
               selectedRowDetails.currentRow
            ] && selectedRowDetails.selectedRowIndex.length === 1
               ? distributionGroupConfig.distributionGroupData[
                    selectedRowDetails.currentRow
                 ].distributionGroupLogs &&
                 distributionGroupConfig.distributionGroupData[
                    selectedRowDetails.currentRow
                 ].distributionGroupLogs
               : [],
      });
      const resultData = calculateMergeData(
         distributionGroupConfig.distributionGroupData[
            selectedRowDetails.currentRow
         ] >= 0 &&
            distributionGroupConfig.distributionGroupData[
               selectedRowDetails.currentRow
            ].distributionGroupLogs
            ? distributionGroupConfig.distributionGroupData[
                 selectedRowDetails.currentRow
              ].distributionGroupLogs
            : DEFAULT_DG_LOG_HEADER,
         distributionGroupConfig.distributionGroupData
      );
      getTableData({
         joinTable: resultData,
         primaryTableLength:
            distributionGroupConfig.distributionGroupData.length,
         totalItem: distributionGroupConfig.distributionGroupData.length,
         isCompleted: true,
      });
   };

   const handleFilterUniqueItems = (item, isSecondaryTable, type) => {
      setDistributionGroupConfig({
         ...distributionGroupConfig,
         isFilterApply: true,
      });
      setTimeout(() => {
         const filterTableData = [
            ...distributionGroupConfig.distributionGroupDefaultData,
         ];
         let filterTableHeader = [
            ...distributionGroupConfig.distributionGroupHeader,
         ];
         let filterFinalTableCollection = [];

         filterTableHeader.forEach((list, index) => {
            if (type === 'clear') {
               if (list.key === item.key) {
                  list.uniqueFilters = getClonedCopyCollections(
                     distributionGroupConfig.distributionGroupDefaultHeader[
                        index
                     ].defaultuniqueFilters
                  );
                  list.uniqueFilters.map((subList) => (subList.value = true));
                  list.width =
                     item.key === 'cur' ||
                     item.key === 'amt' ||
                     item.key === 'sur' ||
                     item.key === 'yq' ||
                     item.key === 'yr'
                        ? item.width - 100
                        : item.key === 'owrt'
                        ? item.width - 100
                        : item.key === 'ft'
                        ? item.width - 70
                        : item.width - 50;
                  list.isFilterApply = false;
               }
            }
            if (list.uniqueFilters.every((item) => item.value === true)) {
               list.uniqueFilters = !list.isFilterApply
                  ? getClonedCopyCollections(
                       distributionGroupConfig.distributionGroupDefaultHeader[
                          index
                       ].defaultuniqueFilters
                    )
                  : getClonedCopyCollections(list.uniqueFilters);
            }
            if (list.key === item.key && type === 'Apply') {
               list.width =
                  item.key === 'cur' ||
                  item.key === 'amt' ||
                  item.key === 'sur' ||
                  item.key === 'yq' ||
                  item.key === 'yr'
                     ? item.width - 100
                     : item.key === 'owrt'
                     ? item.width - 100
                     : item.key === 'ft'
                     ? item.width - 70
                     : item.width - 50;
               list.isFilterApply = true;
            }
            if (!list.isFilterApply) {
               list.uniqueFilters.map((subList) => (subList.value = true));
            }
            return list;
         });
         filterTableData.filter((list) => {
            let unSelectionColumn = [];
            let currentRecordTableKeys = Object.keys(list);
            let currentRecordUpdatedTableKeys = currentRecordTableKeys.filter(
               (item) =>
                  item !== 'id' &&
                  item !== 'isSelect' &&
                  item !== 'selectedField' &&
                  item !== 'selectedColumn' &&
                  item !== 'distributionGroupLogs'
            );

            currentRecordUpdatedTableKeys.filter(
               (item, subIndex, filterCollection) => {
                  const uniqueValueList = filterTableHeader.find(
                     (header) => header.key === item
                  );
                  if (uniqueValueList) {
                     const matchRecords =
                        uniqueValueList.uniqueFilters?.length > 0 &&
                        uniqueValueList.uniqueFilters?.find(
                           (secList) =>
                              secList.value === true &&
                              list[item].toString() === secList.key.toString()
                        );
                     if (!matchRecords) unSelectionColumn.push(item);
                     if (subIndex === filterCollection.length - 1) {
                        if (unSelectionColumn.length === 0)
                           filterFinalTableCollection.push(list);
                     }
                  }
               }
            );
         });
         const headers = updateData(
            distributionGroupConfig.distributionGroupHeader,
            item,
            'closePopup'
         );
         calculateResultDetailsUnique(
            filterFinalTableCollection,
            headers,
            item,
            type
         );

         setDistributionGroupConfig({
            ...distributionGroupConfig,
            distributionGroupHeader: headers,
            distributionGroupData: filterFinalTableCollection,
            isFilterApply: false,
         });
      }, 0);
   };
   const handleFilterChange = (value, item) => {
      setTimeout(() => {
         const finalResult =
            distributionGroupConfig.distributionGroupDefaultData.filter(
               (list) => {
                  if (
                     list[item.key].toString().includes(value) ||
                     list[item.key].toString().includes(value.toUpperCase()) ||
                     list[item.key].toString().includes(value.toLowerCase())
                  ) {
                     return list;
                  }
               }
            );
         const header = updateData(
            distributionGroupConfig.distributionGroupHeader,
            item,
            'filterChanging',
            value
         );

         if (finalResult.length > 0) {
            setDistributionGroupConfig({
               ...distributionGroupConfig,
               distributionGroupData: finalResult,
               distributionGroupHeader: header,
            });
         } else if (finalResult.length === 0 && value) {
            setDistributionGroupConfig({
               ...distributionGroupConfig,
               distributionGroupData: [],
            });
         } else if (!value) {
            setDistributionGroupConfig({
               ...distributionGroupConfig,
               distributionGroupData: finalResult,
               distributionGroupHeader: header,
            });
         }
      }, 0);
   };
   const handleLogTableFilterChange = (value, item) => {
      setTimeout(() => {
         const finalResult =
            distributionGroupConfig.distributionLogDefaultData.filter(
               (list) => {
                  if (
                     list[item.key].toString().includes(value) ||
                     list[item.key].toString().includes(value.toUpperCase()) ||
                     list[item.key].toString().includes(value.toLowerCase())
                  ) {
                     return list;
                  }
               }
            );
         const header = updateData(
            distributionGroupConfig.distributionLogHeader,
            item,
            'filterChanging',
            value
         );

         if (finalResult.length > 0) {
            setDistributionGroupConfig({
               ...distributionGroupConfig,
               distributionLogData: finalResult,
               distributionLogHeader: header,
            });
         } else if (finalResult.length === 0 && value) {
            setDistributionGroupConfig({
               ...distributionGroupConfig,
               distributionLogData: [],
            });
         } else if (!value) {
            setDistributionGroupConfig({
               ...distributionGroupConfig,
               distributionLogData: finalResult,
               distributionLogHeader: header,
            });
         }
      }, 0);
   };
   const handleClearEvent = (item, list, isSecondaryTable) => {
      handleFilterUniqueItems(item, isSecondaryTable, 'clear');
   };
   const handleRecordClick = (
      selectedList,
      selectedItem,
      selectedColumn,
      isShiftKeyPress,
      currentIndex,
      collection,
      type
   ) => {
      if (type === 'otherKey') {
         if (!isShiftKeyPress) {
            const updateResult = getClonedCopyCollections(
               distributionGroupConfig.distributionGroupData
            ).map((list) => {
               if (list.id === selectedList.id) {
                  list.isSelect = true;
                  list.selectedField = selectedItem;
                  list.selectedColumn = selectedColumn;
               } else {
                  list.isSelect = false;
                  list.selectedField = '';
                  list.selectedColumn = '';
               }
               return list;
            });
            if (selectedItem && selectedColumn) {
               setDistributionGroupConfig({
                  ...distributionGroupConfig,
                  distributionGroupData: updateResult,
               });
            }
         } else {
            let updateResult = [];
            const existingIndex = collection.findIndex((list) => list.isSelect);
            if (existingIndex > currentIndex) {
               updateResult = getClonedCopyCollections(
                  distributionGroupConfig.distributionGroupData
               ).map((list, index) => {
                  if (index >= currentIndex && index <= existingIndex)
                     list.isSelect = true;
                  return list;
               });
            } else {
               updateResult = getClonedCopyCollections(
                  distributionGroupConfig.distributionGroupData
               ).map((list, index) => {
                  if (index >= existingIndex && index <= currentIndex)
                     list.isSelect = true;
                  return list;
               });
            }
            setDistributionGroupConfig({
               ...distributionGroupConfig,
               distributionGroupData: updateResult,
            });
         }
      } else {
         const updateResult = getClonedCopyCollections(
            distributionGroupConfig.distributionGroupData
         ).map((list) => {
            if (list.id === selectedList.id) {
               list.isSelect = type === 'ctrlKey' ? !list.isSelect : true;
               list.selectedField = selectedItem;
               list.selectedColumn = selectedColumn;
            }
            return list;
         });
         setDistributionGroupConfig({
            ...distributionGroupConfig,
            distributionGroupData: updateResult,
         });
      }
   };
   const distributionApprove = () => {
      const selectedRowIndexList = [
         ...new Set(
            distributionGroupConfig.selectedRowDetails.selectedRowIndex
         ),
      ];
      if (selectedRowIndexList.length > 0) {
         const payloadApproved = selectedRowIndexList.map((index) => {
            const {
               ['cr user']: user,
               dg,
               email,
               ['int dist dt']: intDistributionTimeStamp,
               ['rel ind']: releaseIndicator,
               ['ex ind']: exclusiveAccessIndicator,
               lfc,
               ['tax ind']: taxIndicator,
            } = distributionGroupConfig.distributionGroupData[index];
            const payload = {
               user: user,
               dgNumber: dg,
               emailId: email,
               carrierCode: fetchConfig.requestedData.hostCarrier,
               exclusiveAccessIndicator: exclusiveAccessIndicator,
               releaseIndicator: releaseIndicator,
               lowFareCheckIndicator: lfc,
               taxIndicator: taxIndicator,
               intDistributionTimeStamp: DateUtil.estTime(
                  new Date(intDistributionTimeStamp)
               ).format(
                  DateUtil.DATE_FORMATS
                     .DOMAIN_DATE_TIME_TIMEZONE_WITH_MILLI_SECONDS_PATTERN
               ),
            };
            if (
               distributionGroupConfig.distributionGroupData.filter(
                  (list) => list.isAllowDistributionApiCall
               ).length > 0
            )
               return payload;
            else {
               delete payload.intDistributionTimeStamp;
               return payload;
            }
         });
         setApprovedApiCall({
            url: URL_DISTRIBUTION_GROUP_APPROVED,
            method: 'POST',
            data: payloadApproved,
         });
         setDistributionGroupConfig({
            ...distributionGroupConfig,
            selectedRowDetails: {
               ...distributionGroupConfig.selectedRowDetails,
               selectedCellTableType: CAMEL_CASE_TYPES.PRIMARY_TABLE,
            },
         });
      }
   };
   useEffect(() => {
      if (newDistributionApiCall) {
         if (newDistributionApiCall.data && !newDistributionApiCall.isLoading) {
            const tableData = clone(
               distributionGroupConfig.distributionGroupData
            );
            const defaultTableData = clone(
               distributionGroupConfig.distributionGroupDefaultData
            );
            tableData.unshift(
               distributionTableParsing([newDistributionApiCall.data])[0]
            );
            const uniqueIdAddedRecords = generateUniqueItem(tableData);
            defaultTableData.unshift(
               distributionTableParsing([newDistributionApiCall.data])[0]
            );
            setDistributionGroupConfig({
               ...distributionGroupConfig,
               distributionGroupData: uniqueIdAddedRecords,
               distributionGroupDefaultData: uniqueIdAddedRecords,
               selectedRowDetails: {
                  currentRow:
                     distributionGroupConfig.selectedRowDetails.currentRow + 1,
                  selectedCellIndex:
                     distributionGroupConfig.selectedRowDetails
                        .selectedCellIndex,
                  selectedCellTableType: CAMEL_CASE_TYPES.PRIMARY_TABLE,
                  selectedRowIndex: [
                     distributionGroupConfig.selectedRowDetails.currentRow + 1,
                  ],
               },
            });
         }
      }
   }, [newDistributionApiCall.isLoading]);
   const newDistributionNumberApi = () => {
      setNewDistributionApiCall({
         method: 'GET',
         url: URL_NEW_DISTRIBUTION_GROUP_GENERATE,
      });
   };
   const filteringSelectedDistributionList = () => {
      const dgList = [
         ...new Set(
            distributionGroupConfig.selectedRowDetails.selectedRowIndex
         ),
      ].map((index) => {
         return distributionGroupConfig.distributionGroupData[index].dg;
      });
      return {
         screen: SCREEN_NAMES.REFERENCE,
         hostCarrier: fetchConfig.requestedData.hostCarrier,
         dgNumber: dgList,
      };
   };
   const removedSelectedDistributionListItems = () => {
      if (
         distributionGroupConfig.selectedRowDetails.selectedRowIndex.length > 0
      ) {
         const availableDistributionRecords = clone(
            distributionGroupConfig.distributionGroupData
         );
         const availableDefauldDistributionRecords = clone(
            distributionGroupConfig.distributionGroupDefaultData
         );
         distributionGroupConfig.selectedRowDetails.selectedRowIndex.map(
            (index) => {
               availableDistributionRecords.splice(index, 1);
               availableDefauldDistributionRecords.splice(index, 1);
            }
         );
         setDistributionGroupConfig({
            ...distributionGroupConfig,
            distributionGroupData: availableDistributionRecords,
            distributionGroupDefaultData: availableDefauldDistributionRecords,
            distributionLogData:
               availableDistributionRecords[0]?.distributionGroupLogs,
            distributionGroupHeader:
               availableDistributionRecords.length > 0
                  ? distributionGroupConfig.distributionGroupHeader
                  : [],
            selectedRowDetails: {
               currentRow: 0,
               selectedCellIndex: 0,
               selectedCellTableType: CAMEL_CASE_TYPES.PRIMARY_TABLE,
               selectedRowIndex: [0],
            },
         });
      }
   };

   const copyDistributionDetails = () => {
      if (
         distributionGroupConfig.selectedRowDetails.selectedRowIndex.length > 0
      ) {
         const result =
            distributionGroupConfig.selectedRowDetails.selectedRowIndex.map(
               (list) => {
                  return distributionGroupConfig.distributionGroupData[list];
               }
            );
         const isCopy = copyTableData(result);
         if (isCopy) {
            showSuccess('Successfully copy selected records');
            setDistributionGroupConfig({
               ...distributionGroupConfig,
               selectedRowDetails: {
                  currentRow:
                     distributionGroupConfig.selectedRowDetails.currentRow,
                  selectedCellIndex:
                     distributionGroupConfig.selectedRowDetails
                        .selectedCellIndex,
                  selectedCellTableType: CAMEL_CASE_TYPES.PRIMARY_TABLE,
                  selectedRowIndex:
                     distributionGroupConfig.selectedRowDetails
                        .selectedRowIndex,
               },
            });
         }
      }
   };
   const parsingDistributionTime = (dateTime) => {
      return DateUtil.estTime(new Date(dateTime)).format(
         DateUtil.DATE_FORMATS
            .DOMAIN_DATE_TIME_TIMEZONE_WITH_MILLI_SECONDS_PATTERN
      );
   };

   const saveDistributionDetails = (data, type) => {
      if (
         !validateIntDistributionDateTime(type, data) &&
         (distributionGroupConfig.distributionGroupData.filter(
            (list) =>
               list.isAllowDistributionApiCall && type === 'main_table_update'
         ).length > 0 ||
            data?.isAllowDistributionApiCall)
      ) {
         toastWarn(NOTIFICATION_MESSAGES.INVALID_DATE_FORMAT);
         return;
      }
      const editedDistributionRecords =
         type === 'log_table_update'
            ? [data]
            : distributionGroupConfig.distributionGroupData.filter(
                 (list) => list.uac === USER_ACTION_CODE_FARES_SCREEN.UPDATE
              );
      if (editedDistributionRecords.length > 0) {
         const resultPayload = editedDistributionRecords.map((list) => {
            const dgLogs =
               list.distributionGroupLogs.length > 0 &&
               list.distributionGroupLogs.map((subList) => {
                  return {
                     action: subList.action,
                     dgNumber: list.dg,
                     timeStamp: subList.timestamp,
                     user: list['cr user'],
                     notes: subList.notes,
                  };
               });
            if (type === 'main_table_update') {
               dgLogs.push({
                  timestamp: DateUtil.estTime(new Date()).format(
                     DateUtil.DATE_FORMATS
                        .DOMAIN_DATE_TIME_TIMEZONE_WITH_MILLI_SECONDS_PATTERN
                  ),
                  user: list['cr user'],
                  action: 'DG UPDATED',
                  notes: list.lastEditedDetails
                     ? `${list.lastEditedDetails} - field is last updated`
                     : '',
               });
            }

            return {
               dgNumber: list.dg,
               createdAt: list.createdAt,
               lastUpdatedAt: list.lastUpdatedAt,
               distributedAt: list['dist dt'],
               description: list.description,
               user: list['cr user'],
               totalFare: list.fare,
               intDistributionTimeStamp: list['int dist dt']
                  ? parsingDistributionTime(list['int dist dt'])
                  : '',
               exclusiveAccessIndicator: list['ex ind'],
               releaseIndicator: list['rel ind'],
               ignoreErrorsIndicator: list['ign err'],
               lowFareCheckIndicator: list.lfc,
               taxIndicator: list['tax ind'],
               justification: list.justification,
               email: list.email,
               status: list.status,
               isDomesticOrInternational: list['d/i'],
               distributionGroupLogs: dgLogs,
            };
         });
         setDistributionSaveApi({
            method: 'PUT',
            url: URL_CORE_PRICING_DELETE_DISTRIBUTION,
            data: resultPayload,
         });
      }
   };
   const undoDistributionList = () => {
      const result = distributionGroupConfig.distributionGroupData.map(
         (list) => {
            if (list.uac === USER_ACTION_CODE_FARES_SCREEN.UPDATE) {
               list = distributionGroupConfig.distributionGroupDefaultData.find(
                  (subList) => subList.dg === list.dg
               );
               delete list.isAllowDistributionApiCall;
               delete list.isDoubleClick;
               return list;
            } else return list;
         }
      );
      setDistributionGroupConfig({
         ...distributionGroupConfig,
         distributionGroupData: result,
         selectedRowDetails: {
            currentRow: distributionGroupConfig.selectedRowDetails.currentRow,
            selectedCellIndex:
               distributionGroupConfig.selectedRowDetails.selectedCellIndex,
            selectedCellTableType: CAMEL_CASE_TYPES.PRIMARY_TABLE,
            selectedRowIndex:
               distributionGroupConfig.selectedRowDetails.selectedRowIndex,
         },
      });
   };
   const navigateToFareScreenWithDGRelatesFares = () => {
      const selectedDgNumber = [
         ...new Set(
            distributionGroupConfig.selectedRowDetails.selectedRowIndex.map(
               (index) =>
                  distributionGroupConfig.distributionGroupData[index].dg
            )
         ),
      ];
      sessionStorage.setItem(
         'distributionNumbers',
         selectedDgNumber.toString()
      );
      window.open('/workflow/fo-core-pricing', '');
   };
   const distributionListApproveAction = (type) => {
      switch (type) {
         case 'Distribute/Approve':
            distributionApprove();
            break;
         case 'New Distribution Group':
            newDistributionNumberApi();
            break;
         case 'Delete':
            const selectedDeleteDGList = filteringSelectedDistributionList();
            handleDeleteDistributionMenuClick(selectedDeleteDGList);
            setDistributionGroupConfig({
               ...distributionGroupConfig,
               selectedRowDetails: {
                  currentRow:
                     distributionGroupConfig.selectedRowDetails.currentRow,
                  selectedCellIndex:
                     distributionGroupConfig.selectedRowDetails
                        .selectedCellIndex,
                  selectedCellTableType: CAMEL_CASE_TYPES.PRIMARY_TABLE,
                  selectedRowIndex:
                     distributionGroupConfig.selectedRowDetails
                        .selectedRowIndex,
               },
            });
            break;
         case 'Remove Selected':
            removedSelectedDistributionListItems();
            break;
         case 'Copy':
            copyDistributionDetails();
            break;
         case 'Save':
            setDistributionGroupConfig({
               ...distributionGroupConfig,
               saveMode: type,
            });
            saveDistributionDetails(undefined, 'main_table_update');
            break;
         case 'Undo Selected':
            undoDistributionList();
            break;
         case 'Show Fares':
            navigateToFareScreenWithDGRelatesFares();
            break;
      }
   };
   const handleLogInputTextChange = (event) => {
      setDistributionGroupConfig({
         ...distributionGroupConfig,
         distributionLogNotesFieldText: event.target.value,
      });
   };

   const handleLogNotesSendClick = () => {
      setDistributionGroupConfig({
         ...distributionGroupConfig,
         saveMode: 'Note',
      });
      if (!distributionGroupConfig.distributionLogNotesFieldText)
         showWarning('Distribution Log Input text field is empty.');
      else {
         const tableData = getClonedCopyCollections(
            distributionGroupConfig.distributionGroupData
         );
         const selectedRowDetails =
            tableData[distributionGroupConfig.selectedRowDetails.currentRow];
         selectedRowDetails.uac = USER_ACTION_CODE_FARES_SCREEN.UPDATE;
         const logs = clone(selectedRowDetails.distributionGroupLogs);
         logs.push({
            timestamp: DateUtil.estTime(new Date()).format(
               DateUtil.DATE_FORMATS
                  .DOMAIN_DATE_TIME_TIMEZONE_WITH_MILLI_SECONDS_PATTERN
            ),
            'cr user': selectedRowDetails['cr user'],
            action: 'NOTE',
            notes: distributionGroupConfig.distributionLogNotesFieldText,
         });
         selectedRowDetails.distributionGroupLogs = logs;
         saveDistributionDetails(selectedRowDetails, 'log_table_update');
      }
   };

   const updateDoubleClickRows = (updatedRow, item) => {
      distributionGroupConfig.distributionGroupData[
         updatedRow.currentRow
      ].isDoubleClick = true;
      distributionGroupConfig.distributionGroupData[updatedRow.currentRow].key =
         item.dataKey;
   };
   const removeCellData = (selectionDetails) => {
      const updatedData = clone(distributionGroupConfig.distributionGroupData);
      updatedData[selectionDetails.row][selectionDetails.key] = '';
      setDistributionGroupConfig({
         ...distributionGroupConfig,
         distributionGroupData: updatedData,
      });
   };

   const handleEditDataUpdated = (value, item, isSecondary, type) => {
      if (type === CAMEL_CASE_ACTION.CHANGE) {
         const updatedData = getClonedCopyCollections(
            distributionGroupConfig.distributionGroupData
         );
         updatedData[item.rowIndex][item.dataKey] = value;
         updatedData[item.rowIndex].uac = USER_ACTION_CODE_FARES_SCREEN.UPDATE;
         if (item.dataKey === 'int dist dt')
            updatedData[item.rowIndex].isAllowDistributionApiCall = true;
         updatedData[item.rowIndex].lastEditedDetails = item.dataKey;
         updatedData[item.rowIndex].isInsert = true;
         setDistributionGroupConfig({
            ...distributionGroupConfig,
            distributionGroupData: updatedData,
         });
      }
      if (type === CAMEL_CASE_ACTION.UPDATES) {
         const editedRecord = clone(
            distributionGroupConfig.distributionGroupData
         );
         editedRecord[item.rowIndex].isDoubleClick = false;
         setDistributionGroupConfig({
            ...distributionGroupConfig,
            distributionGroupData: editedRecord,
         });
      }
   };
   const tableComponent = () => {
      return (
         <div
            className={`${
               distributionGroupConfig.distributionGroupData &&
               distributionGroupConfig.distributionGroupData.length === 0 &&
               'default-height'
            }`}
            tabIndex={0}
            onBlur={() => handleOutSideClick()}
         >
            {!fetchConfig.isLoading &&
            !distributionGroupConfig.isFilterApply ? (
               distributionGroupConfig.distributionGroupHeader.length > 0 ? (
                  <>
                     <div
                        className={`spark-flex ${
                           selectedScreen === 'Reference' ? 'dg-screen' : ''
                        }`}
                     >
                        <TableView
                           rowData={
                              distributionGroupConfig.distributionGroupData
                           }
                           reference={secondaryTableReference}
                           selectedScreen={selectedScreen}
                           distributionListApproveAction={
                              distributionListApproveAction
                           }
                           totalItem={
                              distributionGroupConfig.distributionGroupData
                                 .length
                           }
                           isLeftSideLayoutOpen={
                              distributionGroupConfig.isLeftSideLayoutOpen
                           }
                           getSelectedIndex={getSelectedIndex}
                           selectedRowDetails={
                              distributionGroupConfig.selectedRowDetails
                           }
                           selectedCellIndexValue={
                              distributionGroupConfig.selectedCellIndex
                           }
                           headerData={
                              distributionGroupConfig.distributionGroupHeader
                           }
                           handleSorting={handleSorting}
                           isMultiFilter
                           isToolTipShow
                           handleFilterChange={handleFilterChange}
                           handleClearEvent={handleClearEvent}
                           handleFilterUniqueItems={handleFilterUniqueItems}
                           handleRecordClick={handleRecordClick}
                           fullData={
                              distributionGroupConfig.distributionGroupDefaultData
                           }
                           isStopAPI={fetchConfig.isStopAPI}
                           hostCarrier={fetchConfig.requestedData.hostCarrier}
                           handleEditDataUpdated={handleEditDataUpdated}
                           showWarning={showWarning}
                           title={[]}
                           updateDoubleClicRows={updateDoubleClickRows}
                           removeCellData={removeCellData}
                        />
                        <div className='distribution-log-table'>
                           <TableView
                              rowData={
                                 distributionGroupConfig.distributionLogData &&
                                 distributionGroupConfig.distributionLogData
                                    .length > 0
                                    ? distributionGroupConfig.distributionLogData
                                    : []
                              }
                              selectedScreen={selectedScreen}
                              isScroll
                              isLeftSideLayoutOpen={
                                 distributionGroupConfig.isLeftSideLayoutOpen
                              }
                              getSelectedIndex={getSelectedIndex}
                              headerData={
                                 distributionGroupConfig.distributionLogHeader
                              }
                              handleSorting={handleLogTableSorting}
                              isToolTipShow
                              handleFilterChange={handleLogTableFilterChange}
                              fullData={
                                 distributionGroupConfig.distributionLogData
                              }
                              isLogText
                              isDisabled={
                                 distributionGroupConfig.selectedRowDetails
                                    .selectedRowIndex.length > 1
                                    ? true
                                    : false
                              }
                              showWarning={showWarning}
                              title={[]}
                              handleLogInputTextChange={
                                 handleLogInputTextChange
                              }
                              handleLogNotesSendClick={handleLogNotesSendClick}
                           />
                        </div>
                     </div>
                     {distributionGroupConfig.selectedRowDetails
                        .selectedRowIndex && (
                        <div className='spark-flex justify-space-between'>
                           <div
                              className={
                                 'spark-bold spark-flex justify-space-between'
                              }
                           >
                              {distributionGroupConfig.selectedRowDetails
                                 .selectedRowIndex.length > 0
                                 ? distributionGroupConfig.selectedRowDetails
                                      .selectedRowIndex.length > 1 &&
                                   [
                                      ...new Set(
                                         distributionGroupConfig.selectedRowDetails.selectedRowIndex
                                      ),
                                   ].length
                                 : 0}{' '}
                              {distributionGroupConfig.selectedRowDetails
                                 .selectedRowIndex.length > 1
                                 ? 'r'
                                 : 'R'}
                              ecord
                              {distributionGroupConfig.selectedRowDetails
                                 .selectedRowIndex.length > 1 && 's'}{' '}
                              {distributionGroupConfig.selectedRowDetails
                                 .selectedRowIndex.length === 1 &&
                                 `${
                                    distributionGroupConfig.selectedRowDetails
                                       .currentRow + 1
                                 }`}{' '}
                              selected (Total{' '}
                              {
                                 distributionGroupConfig.distributionGroupData
                                    .length
                              }
                              ){' '}
                           </div>
                        </div>
                     )}
                  </>
               ) : (
                  <div className='spark-flex spark-align-items-center no-record-text spark-bold'>
                     No Distribution result found.
                  </div>
               )
            ) : (
               (fetchConfig.isLoading ||
                  distributionGroupConfig.isFilterApply) && (
                  <Loader
                     className={` ${
                        distributionGroupConfig.isSaveSearchCriteria
                           ? 'loader-container-full'
                           : 'core-pricing-fares-loader'
                     }`}
                     size={SIZE.SMALL}
                  />
               )
            )}
         </div>
      );
   };
   return (
      <div className='distribution-group-root-view'>
         <div className='row distribution-group-root-view-padding-left-right'>
            <LayoutTwoVerticalGrids
               isExpanded={distributionGroupConfig.isLeftSideLayoutOpen}
               leftComponent={searchCriteriaComponent()}
               rightComponent={tableComponent()}
               isCorePricing
               handleStatusLeftSideLayout={handleStatusLeftSideLayout}
            />
         </div>
      </div>
   );
};
DistributionGroup.propTypes = {
   app: object,
   getSearchCriteriaParent: func,
   selectedScreen: string,
   getTableData: func,
   handleDeleteDistributionMenuClick: func,
   deleteConformedDistributionList: array,
};
export default DistributionGroup;
